import React, { createContext, useContext, useState } from "react";

// Create the context
const OtpContext = createContext();

// Provide context to the app
export const OtpProvider = ({ children }) => {
  const [otp, setOtp] = useState({ otp1: "", otp2: "", otp3: "", otp4: "" });

  const handleOtpChange = (newOtp) => {
    setOtp(newOtp);
  };

  return (
    <OtpContext.Provider value={{ otp, handleOtpChange }}>
      {children}
    </OtpContext.Provider>
  );
};

// Custom hook to use OtpContext
export const useOtp = () => {
  return useContext(OtpContext);
};
